import { Component, inject, signal, OnInit } from '@angular/core';
import { KeysComponent } from "../../terminal/keys/keys.component";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { AppTranslateService } from 'src/app/core/service/translate.service';

interface MenuItem {
  label: string
  icon: string
  link: string
}

@Component({
  selector: 'app-view-switcher',
  imports: [KeysComponent, SvgIconComponent, RouterLink],
  templateUrl: './view-switcher.component.html',
  styleUrl: './view-switcher.component.css'
})
export class ViewSwitcherComponent implements OnInit {

  private router = inject(Router)
  private translate = inject(AppTranslateService)

  protected menu: MenuItem[] = [];

  protected activeItem = signal<MenuItem | undefined>(undefined)

  ngOnInit() {
    this.translate.languageChange$.subscribe(() => {
      this.menu = [
        {
          label: this.translate.get('navigation.terminal'),
          icon: 'trade2',
          link: '/terminal'
        },
        {
          label: this.translate.get('navigation.ai'),
          icon: 'ai2',
          link: '/ai'
        }
      ];

      this.activeItem.set(this.menu.find(item => this.router.url.includes(item.link)));
    })

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const activeItem = this.menu.find(item => this.router.url.includes(item.link))
        this.activeItem.set(activeItem)
      }
    })
  }

}
